import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();
  const isInitialMount = useRef(true);
  const lastLocationKey = useRef(location.key);

  useEffect(() => {
    // Set manual scroll restoration so we have full control
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    // Skip on initial mount
    if (isInitialMount.current) {
      isInitialMount.current = false;
      lastLocationKey.current = location.key;
      return;
    }

    // If location key exists and is different from last, it's a new navigation
    // If no location key change, it might be back/forward navigation
    const isNewNavigation = location.key !== lastLocationKey.current;
    
    if (isNewNavigation) {
      // New navigation - scroll to top immediately
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }
    // For back/forward navigation, don't scroll - let browser handle it
    
    lastLocationKey.current = location.key;
  }, [location.pathname, location.key]);

  return null;
};

export default ScrollToTop;